import React from 'react';
import AspireSection from '../components/AspireSection.js';
import AspireCTA from '../components/AspireCTAComponent.js';
import Navbar from '../components/Navbar';
import { Link } from 'react-router-dom';
import '../styles/clientPage.css';
// import PropertyComponent from '../components/PropertyComponent.js';
import CTASection from '../components/CTASection';
import EcoFriendlySection from '../components/EcoFriendlySection.js';
import IntegratedPropertySolutionsSection from '../components/IntegratedPropertySolutionsSection';
import ChrisNote from '../components/ChrisNote';

const PropertyManagementPage = () => {
  return (
    <main className="client-page property-management-page">
      <Navbar />

      {/* Hero Section */}
      <section className="property-hero">
        <img 
          src="/images/maintenance/commercialLand.JPG" 
          alt="Commercial Property Management" 
          className="hero-image"
          loading="eager"
          decoding="async"
        />
        <div className="property-hero-content">
          <h1 className="property-hero-title">Property Management Services</h1>
          <p className="hero-subtitle">
            Managing properties means juggling a lot at once. We're here to make landscape care the easiest part of your job.
          </p>
          <div className="hero-buttons">
            <div className="header-aspire-cta">
              <AspireCTA 
                variant="standard"
                size="large"
                text="Aspire Platform"
                subtext="View updates, schedules & photos"
                icon="📊"
              />
            </div>
            <Link to="/gallery" className="btn-primary">Gallery</Link>
          </div>
        </div>
      </section>
    <ChrisNote/>

      {/* Everything Outside is Our Responsibility */}
      <section className="section bg-white">
        <div className="section-inner">
          <h2 className="section-title text-center">Everything Outside is Our Responsibility</h2>
        </div>
      </section>
      <IntegratedPropertySolutionsSection 
        layout="compact" 
        ctaOverride={{
          link: "mailto:info@allseasons.info",
          text: "Contact Us"
        }}
      />

      {/* Complete Programs */}
      <section className="section bg-white">
        <div className="section-inner">
          <h2 className="section-title text-center">Complete Programs</h2>
        </div>
      </section>
      <section className="maintenance-services-teaser">
        <div className="section-inner">
          <div className="maintenance-teaser-content">
            <div className="maintenance-text">
              <h2>Complete Maintenance Programs</h2>
              <p className="maintenance-subtitle">
                From weekly landscaping to seasonal programs, we handle every detail of outdoor maintenance so you can focus on managing your properties.
              </p>
              
              <div className="maintenance-highlights">
                <div className="highlight-item">
                  <h4>Weekly Landscaping Services</h4>
                  <p>Mowing, edging, pruning, and bed maintenance with guaranteed results</p>
                </div>
                <div className="highlight-item">
                  <h4>Professional Spraying Programs</h4>
                  <p>Fertilization, pest management, and disease prevention with warranty protection</p>
                </div>
                <div className="highlight-item">
                  <h4>Complete Irrigation Management</h4>
                  <p>System installation, seasonal activation, smart programming, and ongoing maintenance</p>
                </div>
              </div>

            </div>
            
            <div className="maintenance-image">
              <img
                src="/images/maintenance/mowingBig1.jpg"
                alt="Professional maintenance services for property management" 
              />
            </div>
          </div>
          
          <div className="maintenance-cta-center">
            <Link to="/Maintenance" className="btn-cta maintenance-cta">
              View All Maintenance Services
            </Link>
          </div>
        </div>
      </section>

      {/* Environmental Safe Blurb */}
      <section className="section bg-white">
        <div className="section-inner">
          <h2 className="section-title text-center">Environmentally Conscious</h2>
        </div>
      </section>
      <EcoFriendlySection 
        layout="compact"
        showTitle={true}
        showCTA={true}
        variant="light"
        context="residential"
      />

      {/* Our Work Speaks for Itself */}
      <section className="section bg-white">
        <div className="section-inner">
          <h2 className="section-title text-center">Our Work Speaks for Itself</h2>
        </div>
      </section>
      <section className="property-showcase">
        <div className="section-inner">
          <div className="showcase-header">
            <h3>OUR WORK SPEAKS</h3>
            <div className="header-line"></div>
          </div>
          <div className="showcase-grid">
            <div className="showcase-image showcase-image--main">
              <img src="/images/maintenance/2people.JPG" alt="Commercial property maintenance" />
              <div className="image-label">
                <span className="label-number">01</span>
                <span className="label-text">COMMERCIAL PROPERTIES</span>
              </div>
            </div>
            <div className="showcase-image showcase-image--secondary">
              <img src="/images/maintenance/hoaLand.JPG" alt="HOA landscaping" />
              <div className="image-label">
                <span className="label-number">02</span>
                <span className="label-text">HOA LANDSCAPES</span>
              </div>
            </div>
            <div className="showcase-image showcase-image--accent">
              <img src="/images/snow/snowPlow.jpg" alt="Snow management" />
              <div className="image-label">
                <span className="label-number">03</span>
                <span className="label-text">EMERGENCY RESPONSE</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Aspire */}
      <section className="section bg-white">
        <div className="section-inner">
          <h2 className="section-title text-center">Aspire</h2>
        </div>
      </section>
      <AspireSection 
        showLogos={false}
        layout="split"
        quoteHighlight={true}
        showCTA={true}
        ctaText="Access Your Property Dashboard"
        ctaLink="https://allseasons.propertyserviceportal.com/"
      />

      {/* Customer Benefits */}
      {/* <CustomerBenefitsSection customerBenefits={residentialData?.customerBenefits} /> */}

      {/* Leave the work to us */}
       <CTASection 
  title="Leave the work to us"
  subtitle="Enjoy outdoor spaces without the hassle. We value attention to detail, consistent service and beautiful landscaping that enhances homes and year-round lifestyle."
  galleryLink="/Gallery"
  showEmergency={false}
/>
    </main>
  );
};

export default PropertyManagementPage;
